import { Flex, Img, useBreakpointValue } from "@chakra-ui/react";
import { useState } from "react";

import { InputWithLabel, InputWithoutLabel } from "@/components/Input";
import { SelectWithLabel } from "@/components/Select";

type FormProps = {
  source?: string;
  hasTwoCards: boolean;
  price: any;
};

export function FormCard({ source, hasTwoCards, price }: FormProps) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });
  const [parcelPrice, setParcelPrice] = useState(price);

  return (
    <Flex alignItems="center">
      <Flex width={["full", "400px"]} mt="20px" direction="column">
        <Flex width="100%" justifyContent="space-between" mb="20px">
          {hasTwoCards && (
            <InputWithLabel
              label="VALOR 1"
              customWidth="95%"
              type="number"
              onChange={(e) => setParcelPrice(e.target.value)}
            />
          )}

          <SelectWithLabel tag="PARCELAMENTO 1" customWidth={["full", "200px"]}>
            <option>1X DE R$ {parcelPrice}</option>
            <option>
              2X DE R${" "}
              {(parseFloat(parcelPrice) / 2).toFixed(2).replace(".", ",")}
            </option>
            <option>
              3X DE R${" "}
              {(parseInt(parcelPrice) / 3).toFixed(2).replace(".", ",")}
            </option>
            <option>
              4X DE R${" "}
              {(parseInt(parcelPrice) / 4).toFixed(2).replace(".", ",")}
            </option>
            <option>
              5X DE R${" "}
              {(parseInt(parcelPrice) / 5).toFixed(2).replace(".", ",")}
            </option>
            <option>
              6X DE R${" "}
              {(parseInt(parcelPrice) / 6).toFixed(2).replace(".", ",")}
            </option>
            <option>
              7X DE R${" "}
              {(parseInt(parcelPrice) / 7).toFixed(2).replace(".", ",")}
            </option>
            <option>
              8X DE R${" "}
              {(parseInt(parcelPrice) / 8).toFixed(2).replace(".", ",")}
            </option>
            <option>
              9X DE R${" "}
              {(parseInt(parcelPrice) / 9).toFixed(2).replace(".", ",")}
            </option>
            <option>
              10X DE R${" "}
              {(parseInt(parcelPrice) / 10).toFixed(2).replace(".", ",")}
            </option>
            <option>
              11X DE R${" "}
              {(parseInt(parcelPrice) / 11).toFixed(2).replace(".", ",")}
            </option>
            <option>
              12X DE R${" "}
              {(parseInt(parcelPrice) / 12).toFixed(2).replace(".", ",")}
            </option>
          </SelectWithLabel>
        </Flex>

        <InputWithoutLabel
          placeholder="NOME NO CARTÃO"
          textTransform="uppercase"
          type="text"
          mb="20px"
        />

        <InputWithoutLabel
          placeholder="CPF DO TITULAR DO CARTÃO"
          type="number"
          mb="20px"
        />

        <InputWithoutLabel
          placeholder="NÚMERO DO CARTÃO"
          type="number"
          mb="20px"
        />

        <Flex width="100%" justifyContent="space-between" mb="20px">
          <InputWithoutLabel
            placeholder="DATA DE EXPIRAÇÃO"
            type="number"
            customWidth="48%"
          />

          <InputWithoutLabel
            placeholder="CVV"
            type="number"
            customWidth="48%"
          />
        </Flex>
      </Flex>

      {isWideVersion && (
        <Flex ml="20px">
          <Img src={source} alt={"Alternative to Image"} />
        </Flex>
      )}
    </Flex>
  );
}
